import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { SalesChartComponent } from "../charts";
import { Dropdown } from "react-bootstrap";

export default function SalesCardComponent ({ingresos, ingresosmensuales}) {

    const { t } = useContext(TranslatorContext)
    // Verificar si ingresos está definido y proporcionar valores predeterminados
    const totalAnual = ingresos?.total_anual || 0;
    const totalMensual = ingresos?.total_mensual || 0;

    return (
        <div className="mc-sales-card">
            <div className="mc-sales-card-group">
                <div className="mc-card-header">
                    <h4 className="mc-card-title">Total Ingresos Año 2025</h4>
                   
                </div>
                <div className='mc-sales-card-amount trending_up green'>
                    <h3>{totalAnual.toLocaleString('es-ES')}</h3>
                   
                </div>
                <p className="mc-sales-card-compare">{totalMensual.toLocaleString('es-ES')} en el último mes en el último mes</p>
            </div>
            <SalesChartComponent ingresosmensuales={ingresosmensuales} />
        </div>
    );
}